/*
 * PDP zoom button. Each gallery image carries a + (snippets/product-gallery.liquid, zoom_button: true).
 * Clicking it opens the theme's PhotoSwipe viewer on that image, then zooms in so the first view is
 * actually magnified. The theme's own zoom toggle stays off: no whole-image cursor, no click-anywhere.
 */
(() => {
  // Zoomed level: fill the viewport, never past the file's native size, never below fit
  const zoomed = (z) => Math.max(z.fit, Math.min(z.fill, 1));

  const setup = (gallery) => {
    const lightBox = gallery.lightBox;
    Object.assign(lightBox.options, {
      initialZoomLevel: 'fit',
      secondaryZoomLevel: (z) => (zoomed(z) > z.fit * 1.1 ? zoomed(z) : Math.min(z.fit * 2.5, 1.5)),
      maxZoomLevel: (z) => Math.max(zoomed(z) * 1.5, 1.5)
    });

    if (!gallery.pdpZoomBound) {
      gallery.pdpZoomBound = true;
      lightBox.on('openingAnimationEnd', () => lightBox.pswp?.currSlide?.toggleZoom());
    }

    return lightBox;
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-pdp-zoom]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const gallery = button.closest('product-gallery');
    const cell = button.closest('.product-gallery__media');
    if (!gallery?.carousel || !cell) return;

    // Only images the shopper can see: skips other colorways and the g-shock overflow
    const cells = Array.from(gallery.querySelectorAll('.product-gallery__media[data-media-type="image"]'))
      .filter((c) => !c.hidden && !c.classList.contains('gallery-overflow') && c.querySelector(':scope > img'));

    const dataSource = cells.map((c) => {
      const image = c.querySelector(':scope > img');
      return {
        thumbnailElement: image,
        src: image.src,
        srcset: image.srcset,
        msrc: image.currentSrc || image.src,
        width: parseInt(image.getAttribute('width')),
        height: parseInt(image.getAttribute('height')),
        alt: image.alt,
        thumbCropped: true
      };
    });

    const index = cells.indexOf(cell);
    if (index < 0) return;

    setup(gallery).loadAndOpen(index, dataSource);
  });
})();

